const KEY = 'fa76158ef82d05eb'

export default function heyzine(data) {
  if (data.url) {
    fetch(`https://heyzine.com/api1/rest?pdf=${data.url}&k=${KEY}&tpl=d62e30604763b9d91b498cb1883c615ba766ed5a.pdf&sv=1`, { method: "GET" } )
    .then((response) => response.json())
    .then((response) => {
      if (response.success == false) {
        document.querySelector("[data-action=close-modal]").click()
        alert("Ops, houve um erro!")
      } else {
        document.querySelector(".fp-iframe").setAttribute("src", response.url)
      }
    })
    .catch((error) => console.error(error))
    .finally()
  }
}
